<template>
	<div>
		<!-- BEGIN #header -->
		<div id="header" class="app-header bg-blue-100" v-bind:class="{ 'app-header-inverse': appOptions.appHeaderInverse }">
			<!-- BEGIN navbar-header -->
			<div class="navbar-header">
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarEndMobile" v-if="appOptions.appSidebarTwo">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link to="/" class="navbar-brand gap-2 text-white">
					<img src="~@/assets/img/logo.png" alt=""><b>Dimenzió</b><span>Egyesület</span>
				</router-link>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleTopMenuMobile" v-if="appOptions.appTopMenu && !appOptions.appSidebarNone">
					<span class="fa-stack fa-lg text-inverse">
						<i class="far fa-square fa-stack-2x"></i>
						<i class="fa fa-cog fa-stack-1x"></i>
					</span>
				</button>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleTopMenuMobile" v-if="appOptions.appTopMenu && appOptions.appSidebarNone">
					<span class="fa fa-bars text-white fa-2x"></span>
				</button>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleHeaderMegaMenuMobile" v-if="appOptions.appHeaderMegaMenu">
					<span class="fa-stack fa-lg text-inverse m-t-2">
						<i class="far fa-square fa-stack-2x"></i>
						<i class="fa fa-cog fa-stack-1x"></i>
					</span>
				</button>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarMobile" v-if="!appOptions.appSidebarNone">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
			</div>
			<!-- END navbar-header -->
			
			<!-- BEGIN header-nav -->
			<div class="navbar-nav" v-if="!user">
				<h1 class="bg-danger p-1 text-white mb-0 h-100 float-end" v-if="dev">DEV</h1>
				<router-link to="/login" class="navbar-item text-white mx-3" style="text-decoration:none;"><i class="fa-solid fa-right-to-bracket"></i> Belépés</router-link>
			</div>
			<div class="navbar-nav" v-else>
				<h1 class="bg-danger p-1 text-white mb-0 h-100 float-end" v-if="dev">DEV</h1>
				<header-mega-menu v-if="appOptions.appHeaderMegaMenu"></header-mega-menu>
				<b-nav-item-dropdown right menu-class="me-1" class="navbar-item navbar-user dropdown m-0" toggle-class="navbar-link dropdown-toggle d-flex align-items-center" no-caret>
					<template v-if="user != null && roles" slot="button-content">
						<div class="image image-icon bg-gray-800 text-gray-200" :title="roles[roles.map(r =>r.id).indexOf(user.role_id)].name">
							<i :class="roles[roles.map(r =>r.id).indexOf(user.role_id)].icon_class"></i>
						</div>
						<div class="d-none d-md-inline text-white" >
							{{user.name}} | {{user.is_member ? 'Tag' : 'Turista'}}
							<b class="caret"></b>
						</div>
					</template>
					<template slot="button-content" v-else>
						<div class="image image-icon bg-gray-800 text-gray-200">
							<i class="fa fa-user"></i>
						</div>
					</template>
					<router-link to="/profile" class="dropdown-item">Profilom</router-link>
					
					<div class="dropdown-divider"></div>
					<a href="javascript:;" class="dropdown-item d-flex align-items-center" @click="logout()">
						Kijelentkezés
						<span class="badge bg-danger rounded-pill ms-auto pb-4px"><i class="fa fa-sign-out-alt"></i></span>
					</a>
				</b-nav-item-dropdown>
				<div class="navbar-divider d-none d-md-block" v-if="appOptions.appSidebarTwo"></div>
				<div class="navbar-item d-none d-md-block" v-if="appOptions.appSidebarTwo">
					<a href="javascript:;" v-on:click="toggleSidebarEnd" class="navbar-link icon">
						<i class="fa fa-th"></i>
					</a>
				</div>
			</div>
			<!-- end header navigation right -->
		</div>
		<!-- end #header -->
		<div id="no_internet" style="position: fixed; display: none; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 6000; cursor: pointer;">
				<div class="widget bg-red p-20px text-center text-white" style="position: absolute;  top: 50%;  left: 50%;  transform: translate(-50%,-50%);  -ms-transform: translate(-50%,-50%);">
					<div class="m-b-md">
							<i class="fa fa-wifi fa-4x"></i>
							<h1 class="m-xs"><i class="fa fa-times"></i></h1>
							<h3 class="font-bold no-margins">
									Hálózati hiba
							</h3>
							<small>Ellenőrizze internetkapcsolatát!</small>
					</div>
				</div>
		</div>
	</div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue'
import HeaderMegaMenu from './HeaderMegaMenu.vue'
import User from '../../apis/User';
import Config from '../../apis/Config';
import axios from "axios";
axios.defaults.withCredentials = true;
	
window.Pusher = require('pusher-js');

export default {
  name: 'Header',
	components: {
		HeaderMegaMenu
	},
  data() {
		return {
			// 5 * 60 * 1000
			timeoutInMS:3600000, 
			timeoutId:false,
			roles:false,
			connection: navigator.onLine,
			appOptions: AppOptions,
		}
  },
	computed:{
		auth(){
			return this.$store.state.auth;
		},
		user(){
			return this.$store.state.user;
		},
		online(){
			return this.$store.state.online;
		},
		dev(){
			return this.$store.state.dev;
		},
	},
	watch:{
		auth(auth) {
			if(auth == false){
				this.logout();	 
			}
		},
		online(online) {
			if(online) {
				document.getElementById("no_internet").style.display = "none";
			}else{
				document.getElementById("no_internet").style.display = "block"; //block
			}
		},
	},
	created(){
		if (window.location.href.indexOf("dev") > -1) {
			this.$store.commit('updateDev',true);
		}
		Config.getVersion()
		.then(response => {
			if(response.data != localStorage.getItem('version')){
				localStorage.setItem('version',response.data);
				Config.getConstants()
				.then(response => {
					localStorage.setItem('constants',JSON.stringify(response.data));
					this.roles = JSON.parse(localStorage.getItem('constants')).roles;
				});
			}else{
				this.roles = JSON.parse(localStorage.getItem('constants')).roles;
			}
		});
		
		User.auth()
		.then(response => {
			console.log('user auth',response.data);
			this.$store.commit('updateUser',response.data);
			localStorage.setItem('user',JSON.stringify(response.data));
			
		}).catch(() => {
			this.logout();
		});
		
		this.setupTimers();
	},
	methods: {
		setTemporary(role){
			this.$bvModal.hide('role-select-modal')
			User.setTemporaryRole({role:role})
			.then(response => {
				this.$store.commit('updateUser',response.data);
				//location.reload();
			})
		},
		logout() {
			User.logout().then(() => {
				this.$store.commit('updateAuth',false);
				this.$store.commit('updateUser',null);
				localStorage.removeItem("auth");
				localStorage.removeItem("user");
				this.$router.push({
					name: "Login"
				});
			})
		},
		toggleSidebarMobile() {
			this.appOptions.appSidebarMobileToggled = !this.appOptions.appSidebarMobileToggled;
		},
		toggleSidebarEnd() {
			this.appOptions.appSidebarEndToggled = !this.appOptions.appSidebarEndToggled;
		},
		toggleSidebarEndMobile() {
			this.appOptions.appSidebarEndMobileToggled = !this.appOptions.appSidebarEndMobileToggled;
		},
		toggleTopMenuMobile() {
			this.appOptions.appTopMenuMobileToggled = !this.appOptions.appTopMenuMobileToggled;
		},
		toggleHeaderMegaMenuMobile() {
			this.appOptions.appHeaderMegaMenuMobileToggled = !this.appOptions.appHeaderMegaMenuMobileToggled;
		},
		checkForm: function(e) {
			e.preventDefault();
			this.$router.push({ path: '/extra/search' })
		},
		handleInactive() {
			this.logout();			
		},
		startTimer() { 			
			this.timeoutId = setTimeout(this.handleInactive, this.timeoutInMS);
		},
		resetTimer() { 
			clearTimeout(this.timeoutId);
			this.startTimer();
		},

		setupTimers () {
			document.addEventListener("keypress", this.resetTimer, false);
			document.addEventListener("mousemove", this.resetTimer, false);
			document.addEventListener("mousedown", this.resetTimer, false);
			document.addEventListener("touchmove", this.resetTimer, false);

			this.startTimer();
		},
		closeDropdown(){
			this.$refs.bellDropdown.hide();
		},
	}
}
</script>
